import { Widget } from '../../../widgets/shared/models/widget';
import { LogQueryModel } from '../../../logs/shared/models/logsquery.model';

export class LoggregationWidget extends Widget {
  public logQueryModel: LogQueryModel;
}
